<div class="page-container" *transloco="let te; read 'events'">

  <p class="title --page">
    {{ te('ourPartnerEvents') }}
  </p>

  <router-outlet/>

  <div class="not-found">
    <p class="not-found__title">
      {{ te('dontFindYourEvent') }}
    </p>
    <p class="not-found__explanation">
      {{ te('needTicketValidation') }}
      <br><br>
      {{ te('toEnableResableForYourEvent') }}
    </p>
  </div>
</div>
